import { useMemo } from "react";
import { BusinessAttributes } from "../types/agent.type";

export function useCustomerAttributes({
  customerAttrs,
  businessAttrs,
  type,
}: {
  customerAttrs: Record<string, any>;
  businessAttrs: BusinessAttributes[];
  type:
    | "call"
    | "callback"
    | "voicemail"
    | "chat"
    | "detail"
    | "case"
    | "case-detail";
}) {
  return useMemo(() => {
    const exclude = new Set<string>();

    if (type === "chat") {
      exclude.add("firstname");
      exclude.add("lastname");
    } else if (type === "case" || type === "case-detail") {
      exclude.add("firstname");
      exclude.add("lastname");
      exclude.add("notes");
      exclude.add("CASE_DESCRIPTION_BASE64".toLowerCase());
      exclude.add("CASE_TITLE".toLowerCase());
      exclude.add("PRODUCTFAMILY".toLowerCase());
      exclude.add("CASEID".toLowerCase());
    }

    const matched: BusinessAttributes[] = [];
    businessAttrs.forEach((attr) => {
      const name = attr.attributeName.toLowerCase();
      const exists = customerAttrs.hasOwnProperty(attr.attributeName);

      if (!exists || exclude.has(name)) return;

      matched.push(attr);
    });

    // for detail component group by 3. for accept dialog group by 2
    const chunkSize = type === "detail" || type === "case-detail" ? 3 : 2;
    const groupedAttributes: BusinessAttributes[][] = [];

    for (let i = 0; i < matched.length; i += chunkSize) {
      groupedAttributes.push(matched.slice(i, i + chunkSize));
    }

    return {
      groupedAttributes,
    };
  }, [customerAttrs, businessAttrs, type]);
}
